import { fetchAllPages } from './fetchAllPages';

export const ALL_PAGE_SIZE = 1000000000;
export const DEFAULT_PAGE_SIZES = [25, 50, 100, 200];

export function isAllPageSize(pageSize) {
  return Number(pageSize) === ALL_PAGE_SIZE;
}

export function getPageSizeOptions({ includeAll = true } = {}) {
  const values = includeAll
    ? [...DEFAULT_PAGE_SIZES, ALL_PAGE_SIZE]
    : [...DEFAULT_PAGE_SIZES];

  const selectOptions = DEFAULT_PAGE_SIZES.map(value => ({
    label: `${value} / стр.`,
    value,
  }));

  if (includeAll) {
    selectOptions.push({ label: 'Все', value: ALL_PAGE_SIZE });
  }

  return { values, selectOptions };
}

export function makeTablePagination({
  current = 1,
  pageSize = 50,
  total,
  showTotal,
  includeAll = true,
} = {}) {
  const { values, selectOptions } = getPageSizeOptions({ includeAll });

  return {
    current,
    pageSize,
    total,
    responsive: true,
    showSizeChanger: { options: selectOptions },
    pageSizeOptions: values,
    showTotal,
  };
}

export function normalizeTablePagination(pagination) {
  const pageSize = Number(pagination?.pageSize || 50);
  return {
    current: isAllPageSize(pageSize) ? 1 : Number(pagination?.current || 1),
    pageSize,
  };
}

export function getServerPaginationParams(pagination) {
  const current = Number(pagination?.current || 1);
  const pageSize = Number(pagination?.pageSize || 50);

  return {
    limit: pageSize,
    offset: (current - 1) * pageSize,
  };
}

export async function fetchServerTableData(
  fetchPage,
  baseParams,
  pagination,
  { batchSize = 500 } = {},
) {
  if (!isAllPageSize(pagination?.pageSize)) {
    return fetchPage({
      ...baseParams,
      ...getServerPaginationParams(pagination),
    });
  }

  const items = await fetchAllPages(
    ({ limit, offset }) => fetchPage({ ...baseParams, limit, offset }),
    { pageSize: batchSize },
  );

  return {
    total: items.length,
    limit: items.length,
    offset: 0,
    items,
  };
}
